export function loadScript(
  uri: string,
  dataset?: Record<string, any> // eslint-disable-line
): Promise<void> {
  return new Promise<void>((resolve, _reject) => {
    const tag = document.createElement("script");
    tag.src = uri;
    tag.async = true;
    tag.type = "text/javascript";
    Object.keys(dataset || {}).forEach((key) => {
      tag.setAttribute(key, dataset[key]);
    });
    tag.onload = () => {
      resolve();
    };
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  });
}
